export const VIDEOS = {
    playback: require('./Speer_Showreel.mp4').default
};